import React from 'react';
import './reserved-cloud-site-audit-logs.scss';
import { Link } from 'react-router-dom';
import { cloudSiteAuditLog, ReservedCloudSite } from '@atlassian/cssxp-typescommon';
import { ColGroup, SearchResultsTable, TableBody, TableHead } from '../../search-results-table';
import { FormattedDate } from '../../formatted';

export interface ComponentProps {
  auditLog?: cloudSiteAuditLog[] | null;
  error?: string | null;
  siteData?: ReservedCloudSite | null | undefined;
}

const getColumns = () => {
  const columns = [
    {
      name: 'Company Name',
      customClassNames: 'col-30',
    },
    {
      name: 'Company Domain',
      customClassNames: 'col-30',
    },
    {
      name: 'Action',
      customClassNames: 'col-30',
    },
    {
      name: 'Ticket Url',
      customClassNames: 'col-30',
    },
    {
      name: 'Date Time',
      customClassNames: 'col-20',
    },
    {
      name: '',
      customClassNames: 'col-10',
    },
  ];
  return columns;
};

export type Props = ComponentProps;

export const ReservedCloudSiteAuditLogs = (props: Props) => {
  const { auditLog = [], error = null, siteData = null } = props;

  const hasNoResults = auditLog?.length === 0;

  return (
    <div data-testid="reserved-site-audit-logs" style={{ order: hasNoResults ? 1 : 0, marginTop: 30 }}>
      <SearchResultsTable
        id="reservedSiteNameSearch"
        isLoading={false}
        error={error?.toString()}
        heading={'Audit Trail'}
        noResults={hasNoResults}
        entityName="Audit trail"
      >
        <ColGroup columns={getColumns()} />
        <TableHead columns={getColumns()} />
        <TableBody>
          {auditLog?.map((logData, index) => {
            const companyName = logData?.payload?.companyName ?? siteData?.companyName ?? 'n/a';
            const companyDomain = logData?.payload?.companyDomain ?? siteData?.companyDomain ?? 'n/a';
            const action = logData?.action ?? null;
            const dateTimeStamp = logData?.timestamp ?? null;
            const ticketUrl = logData?.payload?.ticketUrl ?? null;
            const cloudSiteId = logData?.payload?.ARI ? logData?.payload?.ARI?.split('/')?.[1] : '';

            return (
              <React.Fragment key={`reserved_cloud_site_${index}`}>
                <tr className={'search-result'}>
                  <td>{companyName && companyName !== '' ? companyName : 'n/a'}</td>
                  <td>{companyDomain && companyDomain !== '' ? companyDomain : 'n/a'}</td>
                  <td className="wrap-text">
                    {action && action !== '' ? action : 'n/a'}
                    {action === 'Assign' && cloudSiteId && cloudSiteId !== '' && (
                      <p>
                        <Link
                          to={`/cloud-sites/${cloudSiteId}`}
                          data-testid="cloud-site-id"
                          onClick={(e) => e.stopPropagation()}
                        >
                          {cloudSiteId}
                        </Link>
                      </p>
                    )}
                  </td>
                  <td className="ticket-url wrap-text">
                    {ticketUrl && ticketUrl !== '' ? (
                      <a href={ticketUrl} target="_blank">
                        {ticketUrl}
                      </a>
                    ) : (
                      'n/a'
                    )}
                  </td>
                  <td className="wrap-text">
                    {dateTimeStamp ? (
                      <FormattedDate date={new Date(dateTimeStamp).toISOString()} showTime={true} />
                    ) : (
                      'n/a'
                    )}
                  </td>
                  <td></td>
                </tr>
              </React.Fragment>
            );
          })}
        </TableBody>
      </SearchResultsTable>
    </div>
  );
};
